  <div class="tw-mx-[-20px] tw-mt-5 tw-block tw-rounded tw-border tw-border-gray-200">
    <div class="tw-m-0 tw-flex tw-items-center tw-justify-between tw-rounded-t tw-border-b tw-border-gray-200 tw-bg-gray-50 tw-px-[15px] tw-py-[18px]">
      <div class="tw-flex tw-w-full tw-flex-col tw-items-start tw-gap-2 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between">
        <h6 class="tw-m-0">Confirmations & Reminders</h6>
          <ngx-channel-switch
            [control]="form.controls['enable_communication']"
            label="Enable communication"
            text="Enable communication"
            (changed)="toggleMailCommunication($event)"
          ></ngx-channel-switch>
      </div>
    </div>
    @if (form.controls['enable_communication'].value) {
  <div class="tw-m-0 tw-w-full tw-p-0">
    <div
      class="tw-mt-6 tw-mx-4 tw-flex tw-gap-4 tw-overflow-x-auto tw-overflow-y-hidden tw-border-b tw-border-gray-200 tw-font-inter dark:tw-border-gray-600"
      role="tablist"
      aria-label="Communication channels"
    >
      @for (channel of channels; track channel.id) {
      <button
        type="button"
        role="tab"
        class="{{ channelTabClass }}"
        [ngClass]="{
          'tw-border-blue-600 tw-text-blue-600': communicationChannel === channel.id,
          'tw-border-transparent tw-text-gray-500': communicationChannel !== channel.id,
          'tw-inline-flex': channel.visible,
          'tw-hidden': !channel.visible
        }"
        [attr.aria-selected]="communicationChannel === channel.id"
        (click)="selectCommunicationChannel(channel.id)"
      >
        @switch (channel.id) { @case ('email') {
        <svg class="tw-h-3.5 tw-w-3.5" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path d="M7 7.6398L13.4925 2.0804C13.2432 1.86859 12.9271 1.75158 12.6 1.75H1.4C1.07287 1.75158 0.756802 1.86859 0.5075 2.0804L7 7.6398Z" fill="currentColor" />
          <path
            d="M7.875 8.7339C7.62024 8.92877 7.30884 9.03519 6.9881 9.037C6.6892 9.03761 6.39824 8.94079 6.1593 8.7612L0 3.4888V10.85C0 11.2213 0.1475 11.5774 0.41005 11.8399C0.672601 12.1025 1.0287 12.25 1.4 12.25H12.6C12.9713 12.25 13.3274 12.1025 13.5899 11.8399C13.8525 11.5774 14 11.2213 14 10.85V3.4888L7.875 8.7339Z"
            fill="currentColor"
          />
        </svg>
        } @case ('whatsapp') {
        <svg class="tw-h-3.5 tw-w-3.5" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.9974 1.16748C3.77565 1.16748 1.16406 3.77906 1.16406 7.00081C1.16406 8.10331 1.47031 9.13581 2.0029 10.0155L1.48256 11.7841C1.45269 11.8857 1.45072 11.9934 1.47687 12.096C1.50302 12.1986 1.55632 12.2922 1.63117 12.367C1.70602 12.4419 1.79965 12.4952 1.90222 12.5213C2.00479 12.5475 2.11251 12.5455 2.21406 12.5156L3.98273 11.9953C4.89196 12.5454 5.93469 12.8356 6.9974 12.8341C10.2191 12.8341 12.8307 10.2226 12.8307 7.00081C12.8307 3.77906 10.2191 1.16748 6.9974 1.16748ZM5.6779 8.3209C6.85798 9.5004 7.9844 9.65615 8.38223 9.67073C8.98715 9.6929 9.57631 9.2309 9.80556 8.69481C9.8345 8.62813 9.84501 8.55489 9.83598 8.48275C9.82695 8.41062 9.79872 8.34223 9.75423 8.28473C9.43456 7.8764 9.00231 7.58298 8.57998 7.29131C8.4918 7.23034 8.38344 7.20589 8.27762 7.22307C8.1718 7.24025 8.07675 7.29774 8.0124 7.38348L7.6624 7.91723C7.644 7.94593 7.61532 7.9665 7.58224 7.97474C7.54917 7.98298 7.51419 7.97827 7.48448 7.96156C7.24706 7.82565 6.90115 7.59465 6.65265 7.34615C6.40415 7.09765 6.18715 6.76748 6.06523 6.54523C6.05011 6.51699 6.04574 6.48424 6.05293 6.45302C6.06012 6.42181 6.07837 6.39426 6.10431 6.37548L6.64331 5.97531C6.72023 5.90843 6.76987 5.8156 6.78278 5.71448C6.79569 5.61337 6.77096 5.51104 6.71331 5.42698C6.45198 5.04431 6.14748 4.55781 5.7059 4.23523C5.64891 4.19393 5.58215 4.16818 5.51219 4.16051C5.44223 4.15284 5.37148 4.16351 5.3069 4.19148C4.77023 4.42131 4.3059 5.01048 4.32806 5.61656C4.34265 6.0144 4.4984 7.14081 5.6779 8.3209Z"
            fill="currentColor"
          />
        </svg>
        } @case ('sms') {
        <svg class="tw-h-3.5 tw-w-3.5" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path
            d="M12.6 0.58252H1.4C1.0287 0.58252 0.672601 0.732742 0.41005 1.00014C0.1475 1.26754 0 1.63021 0 2.00837V9.13761C0 9.51577 0.1475 9.87844 0.41005 10.1458C0.672601 10.4132 1.0287 10.5635 1.4 10.5635H3.8822L6.1222 13.172C6.1879 13.2486 6.26893 13.31 6.35984 13.352C6.45076 13.3941 6.54945 13.4159 6.6493 13.4159C6.74915 13.4159 6.84784 13.3941 6.93876 13.352C7.02967 13.31 7.1107 13.2486 7.1764 13.172L9.4178 10.5635H12.6C12.9713 10.5635 13.3274 10.4132 13.5899 10.1458C13.8525 9.87844 14 9.51577 14 9.13761V2.00837C14 1.63021 13.8525 1.26754 13.5899 1.00014C13.3274 0.732742 12.9713 0.58252 12.6 0.58252ZM7 7.71176H3.5C3.31435 7.71176 3.1363 7.63665 3.00503 7.50295C2.87375 7.36925 2.8 7.18792 2.8 6.99884C2.8 6.80976 2.87375 6.62842 3.00503 6.49472C3.1363 6.36102 3.31435 6.28591 3.5 6.28591H7C7.18565 6.28591 7.3637 6.36102 7.49497 6.49472C7.62625 6.62842 7.7 6.80976 7.7 6.99884C7.7 7.18792 7.62625 7.36925 7.49497 7.50295C7.3637 7.63665 7.18565 7.71176 7 7.71176ZM10.5 4.86006H3.5C3.31435 4.86006 3.1363 4.78495 3.00503 4.65125C2.87375 4.51755 2.8 4.33622 2.8 4.14714C2.8 3.95806 2.87375 3.77673 3.00503 3.64303C3.1363 3.50933 3.31435 3.43422 3.5 3.43422H10.5C10.6857 3.43422 10.8637 3.50933 10.995 3.64303C11.1263 3.77673 11.2 3.95806 11.2 4.14714C11.2 4.33622 11.1263 4.51755 10.995 4.65125C10.8637 4.78495 10.6857 4.86006 10.5 4.86006Z"
            fill="currentColor"
          />
        </svg>
        } }
        {{ channel.label }}
      </button>
      }
    </div>
    <div class="tw-relative tw-grid tw-w-full tw-items-start">
      <div
        class="tw-col-start-1 tw-row-start-1 tw-w-full tw-pt-4"
        role="tabpanel"
        [ngClass]="{ 'tw-hidden lg:tw-absolute lg:tw-block lg:tw-invisible lg:tw-pointer-events-none': communicationChannel !== 'email' }"
        [attr.inert]="communicationChannel === 'email' ? null : ''"
      >
      <div class="row !tw-mx-0">
        <div class="col-md-6 mt-2">
          <div class="tw-mb-[1.2rem] tw-flex">
            <div class="col-md-3">Sender name:</div>
            <div class="col-md-9">
              <input
                type="text"
                [formControl]="form.controls['email_from_name']"
                [attr.maxlength]="maxCharLength"
                class="form-control tw-text-xs tw-text-black"
                [ngClass]="{ 'tw-border !tw-border-red-500 !tw-text-red-500 tw-shadow-[0_0_0_0.2rem_rgba(236,63,63,0.25)]': form.controls['email_from_name'].invalid && form.controls['email_from_name'].touched }"
                placeholder="Sender name"
                required
              />
              @if (form.controls['email_from_name'].invalid && form.controls['email_from_name'].touched && form.controls['email_from_name'].errors?.['required']) {
              <div>
                <span class="tw-absolute tw-ps-2 tw-text-xs tw-text-red-500">Sender name is required</span>
              </div>
              }
            </div>
          </div>
          <div class="tw-mb-[1.2rem] tw-flex">
            <div class="col-md-3">Reply to:</div>
            <div class="col-md-9 position-relative">
              <input
                type="email"
                id="email_reply"
                [formControl]="form.controls['email_reply']"
                maxlength="80"
                class="form-control tw-text-xs tw-text-black"
                [ngClass]="{ 'tw-border !tw-border-red-500 !tw-text-red-500 tw-shadow-[0_0_0_0.2rem_rgba(236,63,63,0.25)]': form.controls['email_reply'].invalid && form.controls['email_reply'].touched }"
                placeholder="Reply to"
                required
              />
              @if (form.controls['email_reply'].invalid && form.controls['email_reply'].touched && form.controls['email_reply'].errors?.['pattern']) {
              <div>
                <span class="tw-absolute tw-ps-2 tw-text-xs tw-text-red-500">That doesn't seem an email</span>
              </div>
              }
              @if (form.controls['email_reply'].invalid && form.controls['email_reply'].touched && form.controls['email_reply'].errors?.['required']) {
              <div>
                <span class="tw-absolute tw-ps-2 tw-text-xs tw-text-red-500">Reply to is required</span>
              </div>
              }
            </div>
          </div>
          <div class="tw-mb-[1.2rem] tw-flex">
            <div class="col-md-3">Email subject:</div>
            <div class="col-md-9">
              <input
                type="text"
                [formControl]="form.controls['email_subject']"
                id="email_subject"
                [attr.maxlength]="maxCharLength"
                class="form-control tw-text-xs tw-text-black"
                [ngClass]="{ 'tw-border !tw-border-red-500 !tw-text-red-500 tw-shadow-[0_0_0_0.2rem_rgba(236,63,63,0.25)]': form.controls['email_subject'].invalid && form.controls['email_subject'].touched }"
                placeholder="Email subject"
                required
              />
              @if (form.controls['email_subject'].invalid && form.controls['email_subject'].touched && form.controls['email_subject'].errors?.['required']) {
              <div>
                <span class="tw-absolute tw-ps-2 tw-text-xs tw-text-red-500">Email subject is required</span>
              </div>
              }
            </div>
          </div>
        </div>
        <div class="col-12">
          <h6 class="text-left d-flex">Success Message & Important Info</h6>
        </div>
      </div>
      <div class="d-lg-flex row-cols-lg-2 m-0">
          <div class="">
            <ngx-confirmation-preview [event]="event" [message]="message" [persona]="form.value"></ngx-confirmation-preview>
          </div>
        <div class="tw-flex tw-flex-col tw-gap-2 tw-py-2 lg:tw-px-16">
          <div class="tw-flex tw-items-center tw-gap-4">
            <button
              type="button"
              class="{{ iconButtonClass }}"
              aria-label="Preview confirmation message"
              (click)="previewConfirmation.emit()"
            >
              <svg class="tw-h-5 tw-w-5" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path
                  d="M10 2.5C4.612 2.5 0 8.21714 0 10C0 11.8664 3.546 17.5 10 17.5C16.454 17.5 20 11.8664 20 10C20 8.21714 15.388 2.5 10 2.5ZM10 13.2143C9.40666 13.2143 8.82664 13.0258 8.33329 12.6726C7.83994 12.3194 7.45542 11.8174 7.22836 11.2301C7.0013 10.6427 6.94189 9.99643 7.05764 9.37292C7.1734 8.74941 7.45912 8.17668 7.87868 7.72716C8.29824 7.27763 8.83279 6.9715 9.41473 6.84748C9.99667 6.72345 10.5999 6.78711 11.1481 7.03039C11.6962 7.27367 12.1648 7.68565 12.4944 8.21424C12.8241 8.74282 13 9.36427 13 10C13 10.8525 12.6839 11.67 12.1213 12.2728C11.5587 12.8756 10.7956 13.2143 10 13.2143Z"
                  fill="currentColor"
                />
              </svg>
            </button>
            <p class="tw-m-0 tw-text-sm tw-text-gray-700 dark:tw-text-gray-200">Preview confirmation message</p>
          </div>
          <div class="tw-flex tw-items-center tw-gap-4">
            <button
              type="button"
              class="{{ iconButtonClass }}"
              aria-label="Set reminders"
              (click)="openRemindersDialog()"
            >
              <svg class="tw-h-5 tw-w-5" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path
                  d="M16.1108 11.0862V9.19145C16.1116 7.91087 15.6239 6.6675 14.7265 5.66237C13.8291 4.65725 12.5745 3.94915 11.1656 3.65258C11.1763 3.61584 11.1846 3.57859 11.1906 3.541V1.05262C11.1906 0.773445 11.0651 0.505708 10.8419 0.308304C10.6186 0.110901 10.3158 0 10.0001 0C9.68435 0 9.38155 0.110901 9.15829 0.308304C8.93503 0.505708 8.80961 0.773445 8.80961 1.05262V3.541C8.81553 3.57859 8.82387 3.61584 8.83461 3.65258C7.42569 3.94915 6.1711 4.65725 5.2737 5.66237C4.3763 6.6675 3.88857 7.91087 3.88937 9.19145V11.0862C3.88937 13.5977 1.66675 14.2251 1.66675 15.4808C1.66675 16.105 1.66675 16.7366 2.30722 16.7366H17.6929C18.3334 16.7366 18.3334 16.105 18.3334 15.4808C18.3334 14.2251 16.1108 13.5977 16.1108 11.0862Z"
                  fill="currentColor"
                />
                <path
                  d="M6.21794 17.7892C6.53375 18.445 7.06066 19.0043 7.73313 19.3973C8.40561 19.7904 9.19395 20 10.0001 20C10.8062 20 11.5946 19.7904 12.267 19.3973C12.9395 19.0043 13.4664 18.445 13.7822 17.7892H6.21794Z"
                  fill="currentColor"
                />
              </svg>
            </button>
            <p class="tw-m-0 tw-text-sm tw-text-gray-700 dark:tw-text-gray-200">Set reminders</p>
          </div>
          <div class="tw-flex tw-items-center tw-gap-4">
            <button
              type="button"
              class="{{ iconButtonClass }}"
              aria-label="Change QRCode color"
              (click)="openBarcodeColorDialog()"
            >
              <svg class="tw-h-5 tw-w-5" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <g clip-path="url(#cr-qr-color)">
                  <path
                    d="M19.8168 8.10228C19.3311 5.5763 17.8882 3.33494 15.7887 1.84525C13.6892 0.355555 11.0951 -0.267551 8.547 0.105771C5.99888 0.479094 3.69328 1.82005 2.11064 3.8492C0.528004 5.87836 -0.209589 8.43919 0.0515635 10.9981C0.241914 12.7077 0.866575 14.3403 1.86625 15.741C2.86593 17.1417 4.20745 18.264 5.76348 19.0014C7.07019 19.6455 8.50557 19.9868 9.96269 20H9.97468C10.3727 20.0017 10.767 19.9245 11.135 19.773C11.5029 19.6215 11.8371 19.3986 12.1183 19.1173C12.3983 18.8411 12.6205 18.512 12.7721 18.1493C12.9236 17.7866 13.0015 17.3974 13.0011 17.0043V16.1456C12.9875 16.0044 13.003 15.8619 13.0466 15.7269C13.0902 15.5919 13.161 15.4673 13.2547 15.3606C13.3484 15.254 13.4629 15.1676 13.5912 15.1068C13.7196 15.0461 13.859 15.0122 14.0009 15.0072H16.7004C17.3261 15.0111 17.937 14.8179 18.4464 14.455C18.9558 14.0922 19.3377 13.5782 19.5379 12.9862C20.0381 11.4071 20.134 9.72794 19.8168 8.10228ZM4.50272 11.013C4.30498 11.013 4.11167 10.9545 3.94726 10.8448C3.78284 10.735 3.65469 10.5791 3.57902 10.3966C3.50334 10.2142 3.48354 10.0134 3.52212 9.81969C3.5607 9.62599 3.65592 9.44807 3.79575 9.30842C3.93557 9.16877 4.11372 9.07367 4.30767 9.03514C4.50161 8.99661 4.70264 9.01638 4.88533 9.09196C5.06802 9.16754 5.22417 9.29552 5.33403 9.45973C5.44389 9.62394 5.50253 9.817 5.50253 10.0145C5.50253 10.2793 5.39719 10.5333 5.20969 10.7206C5.02219 10.9078 4.76789 11.013 4.50272 11.013ZM7.20921 7.22555C7.06939 7.36523 6.89125 7.46037 6.69729 7.49892C6.50334 7.53747 6.3023 7.51772 6.11959 7.44215C5.93688 7.36658 5.78071 7.23859 5.67084 7.07438C5.56096 6.91016 5.50232 6.71709 5.50232 6.51958C5.50232 6.32208 5.56096 6.129 5.67084 5.96479C5.78071 5.80057 5.93688 5.67258 6.11959 5.59702C6.3023 5.52145 6.50334 5.50169 6.69729 5.54024C6.89125 5.5788 7.06939 5.67393 7.20921 5.81361C7.39664 6.00086 7.50194 6.2548 7.50194 6.51958C7.50194 6.78436 7.39664 7.0383 7.20921 7.22555ZM10.0807 5.60391C9.88292 5.60391 9.68962 5.54535 9.5252 5.43563C9.36078 5.32591 9.23263 5.16995 9.15696 4.98749C9.08129 4.80503 9.06149 4.60426 9.10007 4.41056C9.13864 4.21686 9.23387 4.03894 9.37369 3.89929C9.51352 3.75964 9.69167 3.66453 9.88561 3.62601C10.0796 3.58748 10.2806 3.60725 10.4633 3.68283C10.646 3.75841 10.8021 3.88639 10.912 4.0506C11.0218 4.21481 11.0805 4.40787 11.0805 4.60537C11.0805 4.8702 10.9751 5.12418 10.7876 5.31145C10.6001 5.49871 10.3458 5.60391 10.0807 5.60391ZM14.2079 7.22555C14.0681 7.36523 13.8899 7.46037 13.696 7.49892C13.502 7.53747 13.301 7.51772 13.1183 7.44215C12.9356 7.36658 12.7794 7.23859 12.6695 7.07438C12.5596 6.91016 12.501 6.71709 12.501 6.51958C12.501 6.32208 12.5596 6.129 12.6695 5.96479C12.7794 5.80057 12.9356 5.67258 13.1183 5.59702C13.301 5.52145 13.502 5.50169 13.696 5.54024C13.8899 5.5788 14.0681 5.67393 14.2079 5.81361C14.3953 6.00086 14.5006 6.2548 14.5006 6.51958C14.5006 6.78436 14.3953 7.0383 14.2079 7.22555Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="cr-qr-color">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <p class="tw-m-0 tw-text-sm tw-text-gray-700 dark:tw-text-gray-200">Change QRCode color</p>
          </div>
          <div class="tw-relative tw-flex tw-items-center tw-gap-4" (click)="$event.stopPropagation()">
            <button
              type="button"
              class="{{ iconButtonClass }}"
              aria-label="Personalize message"
              [attr.aria-expanded]="isVariablesMenuOpen()"
              (click)="isVariablesMenuOpen.set(!isVariablesMenuOpen())"
            >
              <svg class="tw-h-5 tw-w-5" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path
                  d="M18 1.66663H2C1.46957 1.66663 0.960859 1.88612 0.585786 2.27682C0.210714 2.66752 0 3.19742 0 3.74996V16.25C0 16.8025 0.210714 17.3324 0.585786 17.7231C0.960859 18.1138 1.46957 18.3333 2 18.3333H18C18.5304 18.3333 19.0391 18.1138 19.4142 17.7231C19.7893 17.3324 20 16.8025 20 16.25V3.74996C20 3.19742 19.7893 2.66752 19.4142 2.27682C19.0391 1.88612 18.5304 1.66663 18 1.66663ZM6.5 4.79163C6.99445 4.79163 7.4778 4.94436 7.88893 5.23051C8.30005 5.51666 8.62048 5.92337 8.8097 6.39922C8.99892 6.87507 9.04843 7.39868 8.95196 7.90384C8.8555 8.409 8.6174 8.87302 8.26777 9.23722C7.91814 9.60142 7.47268 9.84944 6.98773 9.94992C6.50277 10.0504 6.00011 9.99883 5.54329 9.80173C5.08648 9.60463 4.69603 9.27084 4.42133 8.84259C4.14662 8.41434 4 7.91085 4 7.39579C4 6.70512 4.26339 6.04274 4.73223 5.55437C5.20107 5.06599 5.83696 4.79163 6.5 4.79163ZM3.014 15.2302L3.171 14.5791C3.31091 13.762 3.71982 13.0211 4.32739 12.4841C4.93496 11.947 5.70322 11.6473 6.5 11.6364C7.29276 11.6478 8.05719 11.9453 8.66297 12.4781C9.26874 13.0109 9.67836 13.7461 9.822 14.5583L9.981 15.2062L3.014 15.2302ZM16 14.1666H13C12.7348 14.1666 12.4804 14.0569 12.2929 13.8615C12.1054 13.6662 12 13.4012 12 13.125C12 12.8487 12.1054 12.5837 12.2929 12.3884C12.4804 12.193 12.7348 12.0833 13 12.0833H16C16.2652 12.0833 16.5196 12.193 16.7071 12.3884C16.8946 12.5837 17 12.8487 17 13.125C17 13.4012 16.8946 13.6662 16.7071 13.8615C16.5196 14.0569 16.2652 14.1666 16 14.1666ZM16 11.0416H13C12.7348 11.0416 12.4804 10.9319 12.2929 10.7365C12.1054 10.5412 12 10.2762 12 9.99996C12 9.72369 12.1054 9.45874 12.2929 9.26339C12.4804 9.06804 12.7348 8.95829 13 8.95829H16C16.2652 8.95829 16.5196 9.06804 16.7071 9.26339C16.8946 9.45874 17 9.72369 17 9.99996C17 10.2762 16.8946 10.5412 16.7071 10.7365C16.5196 10.9319 16.2652 11.0416 16 11.0416ZM16 7.91663H13C12.7348 7.91663 12.4804 7.80688 12.2929 7.61153C12.1054 7.41618 12 7.15123 12 6.87496C12 6.59869 12.1054 6.33374 12.2929 6.13839C12.4804 5.94304 12.7348 5.83329 13 5.83329H16C16.2652 5.83329 16.5196 5.94304 16.7071 6.13839C16.8946 6.33374 17 6.59869 17 6.87496C17 7.15123 16.8946 7.41618 16.7071 7.61153C16.5196 7.80688 16.2652 7.91663 16 7.91663Z"
                  fill="currentColor"
                />
              </svg>
            </button>
            <p class="tw-m-0 tw-text-sm tw-text-gray-700 dark:tw-text-gray-200">Personalize message</p>
            @if (isVariablesMenuOpen()) {
            <div class="tw-absolute tw-start-0 tw-top-12 tw-z-20 tw-max-h-60 tw-min-w-[240px] tw-overflow-y-auto tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-py-1 tw-shadow-lg dark:tw-border-gray-600 dark:tw-bg-gray-800">
              @for (variable of messageVariablesList; track variable.title) {
              <button
                type="button"
                class="tw-block tw-w-full tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-text-start tw-text-sm tw-text-gray-700 hover:tw-bg-gray-50 dark:tw-text-gray-200 dark:hover:tw-bg-gray-700"
                (click)="copyMessageVariable(variable.data?.value)"
              >
                {{ variable.title }}
              </button>
              }
            </div>
            }
          </div>
        </div>
      </div>
      <div class="row !tw-mx-0">
        <div class="col-12 mt-4">
          <div class="my-3 pb-3 d-flex">
            <ngx-channel-switch
              [control]="requireApproval"
              label="Require approval"
              text="I want to review & pre-approve registrants of this persona"
            ></ngx-channel-switch>
          </div>
        </div>
      </div>
      @if (requireApproval.value) {
      <div class="row !tw-mx-0 tw-mt-2">
        <div class="col-12">
          <h6 class="text-left d-flex">Pending approval message</h6>
        </div>
      </div>
      <div class="row !tw-mx-0 tw-mb-4">
        <div class="col-12">
          <ngx-confirmation-preview [event]="event" [message]="pendingApprovalMessage" [regret]="true"></ngx-confirmation-preview>
        </div>
      </div>
      <div class="row !tw-mx-0 tw-mt-2">
        <div class="col-12">
          <h6 class="text-left d-flex">Regret message</h6>
        </div>
      </div>
      <div class="row !tw-mx-0 tw-mb-5">
        <div class="col-12">
          <ngx-confirmation-preview [event]="event" [message]="regret" [regret]="true"></ngx-confirmation-preview>
        </div>
      </div>
      }
      </div>
      <ngx-whatsapp-integration
        [whatsappCommunication]="form.controls['whatsapp_communication']"
        [event]="event"
        class="tw-col-start-1 tw-row-start-1 tw-w-full lg:tw-max-h-[750px] lg:tw-overflow-y-auto"
        role="tabpanel"
        [ngClass]="{ 'tw-hidden lg:tw-absolute lg:tw-block lg:tw-invisible lg:tw-pointer-events-none': communicationChannel !== 'whatsapp' }"
        [attr.inert]="communicationChannel === 'whatsapp' ? null : ''"
      ></ngx-whatsapp-integration>
      <ngx-sms-integration
        [smsCommunication]="form.controls['sms_communication']"
        [event]="event"
        class="tw-col-start-1 tw-row-start-1 tw-w-full lg:tw-max-h-[750px] lg:tw-overflow-y-auto"
        role="tabpanel"
        [ngClass]="{ 'tw-hidden': communicationChannel !== 'sms' }"
        [attr.inert]="communicationChannel === 'sms' ? null : ''"
      ></ngx-sms-integration>
    </div>
  </div>
  }
</div>

@if (isRemindersModalOpen()) {
<modal
  [id]="remindersModalId"
  header="Schedule reminders"
  [widthClass]="'tw-w-11/12 tw-max-w-3xl'"
  [heightClass]="'tw-h-auto tw-max-h-[85vh]'"
  (onCloseModal)="closeReminder()"
>
  <div slot="body" class="tw-font-inter">
    <div class="tw-mb-4 tw-flex tw-items-center tw-justify-between tw-gap-4">
      <p class="tw-m-0 tw-text-sm tw-text-gray-700 dark:tw-text-gray-200">Send an email reminder to attendees before the event starts by:</p>
      <ngx-channel-switch [control]="reminderStatus" label="Enable reminders"></ngx-channel-switch>
    </div>
    @for (schedule of formSchedules.controls; track $index) {
    <ngx-reminder-schedule
      [schedule]="schedule"
      [isFirstSchedule]="$index === 0"
      [isOnlySchedule]="formSchedules.controls.length <= 1"
      [reminderPrice]="reminderPrice"
      (removeSchedule)="removeReminder($index)"
    ></ngx-reminder-schedule>
    }
    @if (formSchedules.length < maxReminders) {
    <button type="button" class="tw-border-0 tw-bg-transparent tw-p-0 tw-text-sm tw-text-blue-600" (click)="addReminder()">Add reminder</button>
    }
  </div>
  <div slot="footer" class="tw-flex tw-items-center tw-justify-between tw-border-t tw-border-gray-200 tw-px-6 tw-py-4 dark:tw-border-gray-600">
    <button
      type="button"
      class="tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-border-gray-600 dark:tw-bg-gray-800 dark:tw-text-gray-200"
      (click)="dismissReminders()"
    >
      CANCEL
    </button>
    <button
      type="button"
      class="tw-rounded-lg tw-border-0 tw-bg-blue-600 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white disabled:tw-opacity-50"
      [disabled]="formSchedules.invalid"
      (click)="saveReminders()"
    >
      SAVE
    </button>
  </div>
</modal>
}
@if (isBarcodeModalOpen()) {
<modal
  [id]="barcodeModalId"
  header="Barcode color"
  [widthClass]="'tw-w-11/12 tw-max-w-2xl'"
  [heightClass]="'tw-h-auto tw-max-h-[85vh]'"
  (onCloseModal)="restoreBarcodeColor()"
>
  <div slot="body" class="tw-font-inter">
    <p class="tw-m-0 tw-mb-4 tw-text-sm tw-text-gray-700 dark:tw-text-gray-200">Please choose the barcode color that will be visible to the event registrants</p>
    <div class="tw-flex tw-flex-wrap tw-gap-3" role="radiogroup" aria-label="Barcode color">
      @for (color of colorList; track color.value) {
      <button
        type="button"
        role="radio"
        class="tw-box-border tw-flex tw-h-10 tw-w-[140px] tw-cursor-pointer tw-items-center tw-justify-center tw-rounded tw-border-2 tw-border-solid tw-text-sm tw-text-white tw-outline-none tw-transition-none focus:tw-outline-none"
        [style.background]="color.value"
        [style.outline]="'none'"
        [attr.aria-checked]="barcodeColor === color.value"
        [ngClass]="{
          'tw-border-[#c5cee0] tw-font-bold tw-shadow-[0_0_0_2px_#fff,0_0_0_4px_#222b45]': barcodeColor === color.value,
          'tw-border-transparent tw-shadow-none': barcodeColor !== color.value
        }"
        (click)="selectBarcodeColor(color.value)"
      >
        {{ color.name }}
      </button>
      }
    </div>
  </div>
  <div slot="footer" class="tw-flex tw-justify-end tw-border-t tw-border-gray-200 tw-px-6 tw-py-4 dark:tw-border-gray-600">
    <button type="button" class="tw-rounded-lg tw-border-0 tw-bg-[#1C64F2]  tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white" (click)="saveBarcodeAndClose()">SAVE</button>
  </div>
</modal>
}
